import { fetchApi } from '@/config/api'
import type {
  SectorizationCountry,
  VendorSectorizationResponse,
  SaveSectorizationResponse,
} from '@/types/salesSectorization'

const GET_ALL_COUNTRIES_QUERY = `
  query GetAllCountries {
    pays {
      id_pays
      code
      texte_fr
    }
  }
`

const GET_VENDOR_SECTORIZATION_QUERY = `
  query GetVendorSectorization {
    me {
      id_vendeur
      secteurs {
        id_pays
        id_vendeur_marque
        codePostal
      }
    }
  }
`

const SAVE_SALES_SECTORIZATION_MUTATION = `
  mutation SaveSalesSectorization(
    $excludedCountries: [Int!]!
    $excludedDomTom: [String!]!
    $excludedDepartments: [String!]!
  ) {
    saveSalesSectorization(
      excludedCountries: $excludedCountries
      excludedDomTom: $excludedDomTom
      excludedDepartments: $excludedDepartments
    ) {
      success
      message
    }
  }
`

export async function getAllCountries(): Promise<SectorizationCountry[]> {
  const response = await fetchApi<{ pays: SectorizationCountry[] }>(GET_ALL_COUNTRIES_QUERY)
  return response.pays
}

export async function getVendorSectorization(): Promise<VendorSectorizationResponse['me']> {
  const response = await fetchApi<VendorSectorizationResponse>(GET_VENDOR_SECTORIZATION_QUERY)
  return response.me
}

export async function saveSalesSectorization(
  excludedCountries: number[],
  excludedDomTom: string[],
  excludedDepartments: string[],
): Promise<{ success: boolean; message: string }> {
  const response = await fetchApi<SaveSectorizationResponse>(SAVE_SALES_SECTORIZATION_MUTATION, {
    excludedCountries,
    excludedDomTom,
    excludedDepartments,
  })
  return response.saveSalesSectorization
}
